import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { base44 } from '@/api/base44Client';
import { Download, Loader2 } from 'lucide-react';
import { format } from 'date-fns';

export default function ExportExcelButton() {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);

    const [bookings, orders] = await Promise.all([
      base44.entities.Booking.list('-created_date', 1000),
      base44.entities.Order.list('-created_date', 1000),
    ]);

    // Bookings sheet
    const bookingRows = bookings.map(b => ({
      'Date': b.date || '',
      'Time Slot': b.time_slot || '',
      'Customer Name': b.customer_name || '',
      'Customer Email': b.customer_email || '',
      'Customer Phone': b.customer_phone || '',
      'Experience': b.experience_type || '',
      'Rig': b.rig_type || '',
      'Duration (hrs)': b.duration || 1,
      'Total (£)': b.total_price || 0,
      'Status': b.status || '',
      'Notes': b.notes || '',
      'Created': b.created_date ? format(new Date(b.created_date), 'dd/MM/yyyy HH:mm') : '',
    }));

    // Orders sheet
    const orderRows = orders.map(o => ({
      'Customer Name': o.customer_name || '',
      'Customer Email': o.customer_email || '',
      'Customer Phone': o.customer_phone || '',
      'Product': o.product_name || '',
      'Amount (£)': o.amount || 0,
      'Status': o.status || '',
      'Tracking #': o.tracking_number || '',
      'Address Line 1': o.delivery_address_line1 || '',
      'Address Line 2': o.delivery_address_line2 || '',
      'City': o.delivery_city || '',
      'Postcode': o.delivery_postcode || '',
      'Notes': o.notes || '',
      'Created': o.created_date ? format(new Date(o.created_date), 'dd/MM/yyyy HH:mm') : '',
    }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(bookingRows), 'Bookings');
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(orderRows), 'Orders');

    const filename = `motion-reality-export-${format(new Date(), 'yyyy-MM-dd')}.xlsx`;
    XLSX.writeFile(wb, filename);

    setLoading(false);
  };

  return (
    <button
      onClick={handleExport}
      disabled={loading}
      className="flex items-center gap-2 border border-white/10 hover:border-primary/50 text-white/50 hover:text-white text-xs font-bold tracking-wider px-4 py-2.5 transition-all disabled:opacity-40 disabled:cursor-not-allowed"
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
      EXPORT EXCEL
    </button>
  );
}